import React from "react";
import classes from "./CartRowForCheckOut.module.css";
export default function CartRowForCheckOut(props) {
  return (
    <div className={classes.cartProductContainer}>
      <div className={classes.cartProductImageContainer}>
        <img alt="cart" src={props?.image} />
      </div>
      <div className={classes.cartName}>{props?.name}</div>
      <div className={classes.cartQty}>{props?.qty}</div>
      <div className={classes.cartPrice}>{props?.price} EUR</div>
    </div>
  );
}
